/**
 * @generated SignedSource<<e8021d465f88925a457c05866d124ef6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RssMaxAge = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "%future added value";
export type RssMaxItemsPerEpisode = "FIVE" | "ONE" | "TEN" | "THREE" | "%future added value";
export type RssProcessingDelay = "INSTANT" | "ONE_DAY" | "ONE_HOUR" | "SIX_HOURS" | "TWO_DAYS" | "%future added value";
export type SourceType = "BING_NEWS" | "GOOGLE_NEWS" | "REDDIT" | "RSS" | "SERPER_NEWS" | "TWITTER" | "YOU_TUBE" | "%future added value";
export type TopicType = "NEWS" | "RSS" | "%future added value";
export type TopicVisibility = "PRIVATE" | "PUBLIC" | "UNLISTED" | "%future added value";
export type TtsEngine = "ELEVEN_LABS" | "POLLY" | "%future added value";
export type UpdateTopicInput = {
  applePodcastsUrl?: string | null | undefined;
  cronSchedule?: string | null | undefined;
  customHostName?: string | null | undefined;
  customHostPersonality?: string | null | undefined;
  name?: string | null | undefined;
  rssSettings?: RssSettingsInput | null | undefined;
  s3AnchorImagePath?: string | null | undefined;
  s3IntroPath?: string | null | undefined;
  s3OutroPath?: string | null | undefined;
  sources?: ReadonlyArray<SourceInput> | null | undefined;
  spotifyUrl?: string | null | undefined;
  stylePrompt?: string | null | undefined;
  topicType?: TopicType | null | undefined;
  ttsEngine?: TtsEngine | null | undefined;
  ttsModel?: string | null | undefined;
  visibility?: TopicVisibility | null | undefined;
  voiceId?: string | null | undefined;
};
export type SourceInput = {
  domainFilter?: string | null | undefined;
  identifier: string;
  label?: string | null | undefined;
  sourceType: SourceType;
};
export type RssSettingsInput = {
  maxAge: RssMaxAge;
  maxItemsPerEpisode: RssMaxItemsPerEpisode;
  processingDelay: RssProcessingDelay;
};
export type TopicFormUpdateMutation$variables = {
  input: UpdateTopicInput;
  slug: string;
};
export type TopicFormUpdateMutation$data = {
  readonly updateTopic: {
    readonly topic: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TopicForm_topic">;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type TopicFormUpdateMutation = {
  response: TopicFormUpdateMutation$data;
  variables: TopicFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserError",
  "kind": "LinkedField",
  "name": "userErrors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateTopicPayload",
        "kind": "LinkedField",
        "name": "updateTopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopicForm_topic"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopicFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateTopicPayload",
        "kind": "LinkedField",
        "name": "updateTopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "sources",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "identifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "domainFilter",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voiceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttsEngine",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttsModel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stylePrompt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customHostName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customHostPersonality",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "topicType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RssSettings",
                "kind": "LinkedField",
                "name": "rssSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxItemsPerEpisode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxAge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "processingDelay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cronSchedule",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "s3IntroPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "s3OutroPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "s3AnchorImagePath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spotifyUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applePodcastsUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88d7182e33aec79ab568d29f4de99d0d",
    "id": null,
    "metadata": {},
    "name": "TopicFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TopicFormUpdateMutation(\n  $slug: String!\n  $input: UpdateTopicInput!\n) {\n  updateTopic(slug: $slug, input: $input) {\n    topic {\n      id\n      ...TopicForm_topic\n    }\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n\nfragment TopicForm_topic on Topic {\n  id\n  slug\n  name\n  sources {\n    sourceType\n    identifier\n    label\n    domainFilter\n  }\n  voiceId\n  ttsEngine\n  ttsModel\n  stylePrompt\n  customHostName\n  customHostPersonality\n  visibility\n  topicType\n  rssSettings {\n    maxItemsPerEpisode\n    maxAge\n    processingDelay\n  }\n  cronSchedule\n  s3IntroPath\n  s3OutroPath\n  s3AnchorImagePath\n  spotifyUrl\n  applePodcastsUrl\n}\n"
  }
};
})();

(node as any).hash = "a2885bb20c96c0b35399869ee726e52e";

export default node;
